
html, body {
  margin: 0; /* Removes default browser margins */
  padding: 0; /* Removes default browser padding */
  height: 100%;
  width: 100%;
}

body {
  background-color: #f0f0f0;
  font-family: sans-serif;
}

div#loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
}


